// UserPanel.js — Mes soumissions + admin modération

import React, { useState, useEffect } from 'react';
import { signOut, getUserEvents, getPendingEvents, updateEventStatus } from '../lib/supabase';
import { CATEGORIES, formatYear } from '../data/events';

const ADMIN_EMAIL = 'charles.boinnard@gmail.com'; // ← votre email admin

export function UserPanel({ user, onClose, onSignOut }) {
  const [myEvents, setMyEvents]     = useState([]);
  const [pending, setPending]       = useState([]);
  const [tab, setTab]               = useState('mine');
  const [loading, setLoading]       = useState(true);

  const isAdmin = user.email === ADMIN_EMAIL;

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    setLoading(true);
    const { data } = await getUserEvents(user.id);
    setMyEvents(data || []);
    if (isAdmin) {
      const { data: p } = await getPendingEvents();
      setPending(p || []);
    }
    setLoading(false);
  };

  const approve = async (id) => {
    await updateEventStatus(id, 'approved');
    setPending(prev => prev.filter(e => e.id !== id));
  };

  const reject = async (id) => {
    await updateEventStatus(id, 'rejected');
    setPending(prev => prev.filter(e => e.id !== id));
  };

  const handleSignOut = async () => {
    await signOut();
    onSignOut();
    onClose();
  };

  const statusInfo = (s) => ({
    pending:  { label: 'En attente', color: '#f59e0b' },
    approved: { label: 'Approuvé',   color: '#10b981' },
    rejected: { label: 'Refusé',     color: '#ef4444' },
  }[s] || { label: s, color: '#888' });

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box modal-large" onClick={e => e.stopPropagation()}>
        <button className="close-btn modal-close" onClick={onClose}>×</button>

        <div className="user-header">
          <div className="user-avatar">{user.email[0].toUpperCase()}</div>
          <div className="user-info">
            <span className="user-email">{user.email}</span>
            {isAdmin && <span className="admin-badge">⭐ Admin</span>}
          </div>
          <button className="signout-btn" onClick={handleSignOut}>Déconnexion</button>
        </div>

        <div className="modal-tabs">
          <button className={`modal-tab ${tab==='mine'?'active':''}`} onClick={() => setTab('mine')}>
            Mes soumissions ({myEvents.length})
          </button>
          {isAdmin && (
            <button className={`modal-tab ${tab==='admin'?'active':''}`} onClick={() => setTab('admin')}>
              Modération {pending.length > 0 && <span className="badge-red">{pending.length}</span>}
            </button>
          )}
        </div>

        {loading ? (
          <div className="modal-loading">Chargement…</div>
        ) : tab === 'mine' ? (
          <div className="events-list">
            {myEvents.length === 0
              ? <p className="empty-msg">Vous n'avez pas encore soumis d'événements.<br/>Cliquez sur ✚ pour contribuer !</p>
              : myEvents.map(ev => {
                  const cat = CATEGORIES[ev.category] || CATEGORIES.POLITICS;
                  const st  = statusInfo(ev.status);
                  return (
                    <div key={ev.id} className="event-list-item">
                      <span className="eli-icon">{cat.icon}</span>
                      <div className="eli-info">
                        <span className="eli-title">{ev.title}</span>
                        <span className="eli-year" style={{color: cat.color}}>{formatYear(ev.year)}</span>
                      </div>
                      <span className="eli-status" style={{color: st.color}}>{st.label}</span>
                    </div>
                  );
                })
            }
          </div>
        ) : (
          <div className="events-list">
            {pending.length === 0
              ? <p className="empty-msg">Aucun événement en attente de validation.</p>
              : pending.map(ev => {
                  const cat = CATEGORIES[ev.category] || CATEGORIES.POLITICS;
                  return (
                    <div key={ev.id} className="event-list-item admin-item">
                      <span className="eli-icon">{cat.icon}</span>
                      <div className="eli-info">
                        <span className="eli-title">{ev.title}</span>
                        <span className="eli-year">{formatYear(ev.year)} — {ev.lat?.toFixed(2)}°, {ev.lng?.toFixed(2)}°</span>
                        <span className="eli-desc">{ev.description?.slice(0, 100)}…</span>
                        <span className="eli-by">📧 {ev.user_email}</span>
                      </div>
                      <div className="admin-actions">
                        <button className="admin-btn approve" onClick={() => approve(ev.id)} title="Approuver">✓</button>
                        <button className="admin-btn reject"  onClick={() => reject(ev.id)}  title="Rejeter">✗</button>
                      </div>
                    </div>
                  );
                })
            }
          </div>
        )}
      </div>
    </div>
  );
}
